// src/components/blog/BlogCategories.jsx

import React, { memo } from 'react';

const BlogCategories = memo(({ categories, activeCategory, onCategoryChange, isDark }) => {
  return (
    <div className={`mb-8 p-6 rounded-xl ${isDark ? 'bg-white/5 border border-white/10' : 'bg-white border border-gray-200'}`}>
      <h3 className={`text-lg font-bold mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`}>
        Categories
      </h3>
      <div className="space-y-2">
        {categories.map((category) => (
          <button
            key={category.id}
            onClick={() => onCategoryChange(category.slug)}
            className={`w-full flex justify-between items-center px-3 py-2 rounded-lg transition-all ${
              activeCategory === (category.slug || category.id)
                ? 'bg-gradient-to-r from-blue-700 to-blue-900 text-white'
                : isDark
                  ? 'hover:bg-white/10 text-gray-300'
                  : 'hover:bg-gray-100 text-gray-600'
            }`}
            aria-label={`Filter by ${category.name}`}
          >
            <span>{category.name}</span>
            <span className="text-xs">{category.count}</span>
          </button>
        ))}
      </div>
    </div>
  );
});

BlogCategories.displayName = 'BlogCategories';

export default BlogCategories;